"use client";

import { ElementType, ReactNode, forwardRef } from "react";
import { AspectRatio, Box, BoxProps, Flex } from "@chakra-ui/react";

type Props = {
  href?: string;
  onClick?: VoidFunction;
  children: ReactNode;
  icon?: ReactNode;
  element?: ElementType;
  ratio?: number;
  count?: number;
} & BoxProps;

const Tile = forwardRef<HTMLElement, Props>(
  (
    {
      href,
      onClick,
      element: Element = "a",
      children,
      icon,
      ratio = 1,
      count,
      ...props
    },
    ref,
  ) => (
    <Box position="relative" ref={ref}>
      <AspectRatio ratio={ratio}>
        <Box
          asChild
          flexDirection="column"
          bg="#edf2f7"
          height={80}
          px={4}
          py={6}
          textAlign="center"
          lineHeight={1.2}
          transition="background-color 150ms ease-in-out"
          borderRadius={10}
          cursor="pointer"
          _hover={{ bg: "#e2e8f0" }}
          {...props}
        >
          <Element href={href} onClick={onClick}>
            {icon && (
              <Flex
                flexGrow={1}
                alignItems="center"
                justifyContent="center"
                maxWidth={140}
              >
                {icon}
              </Flex>
            )}

            {children}

            {count ? (
              <Box
                as="span"
                position="absolute"
                top={2}
                right={3}
                color="primary"
                fontWeight={700}
              >
                {count}
              </Box>
            ) : null}
          </Element>
        </Box>
      </AspectRatio>
    </Box>
  ),
);

export default Tile;
